import type { AnimationStyle } from "./animated-image.ts";
import type { SourceImagePromptType } from "./source-image.ts";

interface AnimationStyleConfig {
  startImagePromptType?: SourceImagePromptType;
  endImagePromptType?: SourceImagePromptType;
  copyStartImageToEndImage?: boolean;
}

export const styleConfigs: Partial<
  Record<AnimationStyle, AnimationStyleConfig>
> = {
  SUNSET: {
    startImagePromptType: "SUNSET",
  },
  TWILIGHT: {
    startImagePromptType: "TWILIGHT",
  },
  NIGHT: {
    startImagePromptType: "NIGHT",
  },
  SUNRISE: {
    startImagePromptType: "SUNRISE",
  },
  MIDDAY: {
    startImagePromptType: "MIDDAY",
  },
  AFTERNOON: {
    startImagePromptType: "AFTERNOON",
  },
  FIREPLACE: {
    startImagePromptType: "FIREPLACE",
  },
  DECLUTTER: {
    startImagePromptType: "DECLUTTER",
  },
  TV: {
    startImagePromptType: "TV",
  },
  FOG: {
    startImagePromptType: "FOG",
    copyStartImageToEndImage: true,
  },
  HELICOPTER: {
    startImagePromptType: "HELICOPTER",
    copyStartImageToEndImage: true,
  },
  HOUSE_DROP: {
    startImagePromptType: "HOUSE_REMOVE",
    copyStartImageToEndImage: true,
  },
  HOUSE_JUMP: {
    startImagePromptType: "HOUSE_REMOVE",
    copyStartImageToEndImage: true,
  },
  PENCIL_DRAWING: {
    startImagePromptType: "PENCIL_DRAWING",
    copyStartImageToEndImage: true,
  },
  FURNITURE_REVEAL: {
    startImagePromptType: "FURNITURE_REMOVE",
    copyStartImageToEndImage: true,
  },
  FURNITURE_REVEAL_SE: {
    startImagePromptType: "FURNITURE_REMOVE",
  },
  TIMELAPSE_DAY_TO_NIGHT: {
    startImagePromptType: "MIDDAY",
    endImagePromptType: "NIGHT",
    copyStartImageToEndImage: true,
  },
  TIMELAPSE_NIGHT_TO_DAY: {
    startImagePromptType: "NIGHT",
    endImagePromptType: "MIDDAY",
    copyStartImageToEndImage: true,
  },
  TIMELAPSE_SUNRISE: {
    startImagePromptType: "NIGHT",
    endImagePromptType: "SUNRISE",
    copyStartImageToEndImage: true,
  },
  TIMELAPSE_SUNSET: {
    startImagePromptType: "AFTERNOON",
    endImagePromptType: "SUNSET",
    copyStartImageToEndImage: true,
  },
  MAGAZINE: {
    startImagePromptType: "MAGAZINE",
    copyStartImageToEndImage: true,
  },
  NEWSPAPER: {
    startImagePromptType: "NEWSPAPER",
    copyStartImageToEndImage: true,
  },
};
